<template lang="pug">
  nav.navigation
    template(
      v-for="page of pages"
    )
      a.navigation__link(
        v-if="page.type === 'link'"
        :href="page.url"
        target="_blank"
      ) {{ page.title }}
      RouterLink.navigation__link(
        v-else
        :to="`/${page.id}`"
      ) {{ page.title }}
</template>

<script>
import content from '@/content'

export default {
  data() {
    return {
      pages: []
    }
  },

  created() {
    this.load()
  },

  methods: {
    async load() {
      this.pages = await content.get('pages')
    }
  }
}
</script>

<style lang="scss">
@import '~@/settings';

.navigation {
  padding: 0.7rem 1rem;

  background: map-get($bg-color, light);
  border-bottom: 1px solid map-get($border-color, light);

  font-size: map-get($font-size, medium);

  &,
  a {
    color: map-get($color, darker);
    text-decoration: none;
  }

  a:hover {
    color: map-get($color, dark);
  }

  > * {
    margin-right: 2em;
  }
}
</style>
